import loadingPage from './loading.vue';

const loading = {
    install: function(Vue) {
        Vue.component('loading', loadingPage)
    }
}

export default loading;